module.exports = __webpack_public_path__ + "static/media/sheisedo-zen.cfc28a52.png";